// src/ForbiddenPage.jsx

import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ForbiddenPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h4" color="error">
        403 - 접근 금지
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>
        이 페이지는 관리자만 접근할 수 있습니다.
      </Typography>
      <Button variant="outlined" sx={{ mt: 3 }} onClick={() => navigate('/')}>
        메인으로 돌아가기
      </Button>
    </Box>
  );
};

export default ForbiddenPage;